/**
 * Ссылка на API бэка с цветами
 * @type {string}
 */
const API_URL = "https://primeservices.technolab.com.ru";

/**
 * Тоекен для доступа к API_URL
 * @type {string}
 */
const X_APP_TOKEN = "928ce0cf-adbe-4ab7-ab3e-76bbf0f78fb3";

/**
 * Ссылка на сервис на который слать GraphQL запросы
 * @type {string}
 */
const GRAPHQL_API_URL = "https://demo.primeconcept.co.uk";

/**
 * Количество дне которые выводим в календаре
 * @type {number}
 */
const DAYS_IN_LIST = 31;

/**
 * Сколько минут добавлять к дедлайну
 * @type {number}
 */
const DEADLINE_ADD_MINUTES = 15;

/**
 * Сколько минут добавлять к дедлайну доставки
 * @type {number}
 */
const DEADLINE_ADD_MINUTES_DELIVERY = 30;

/**
 * Часовой пояс для дедлайнов заказа в CRM
 * @type {string}
 */
const MOSCOW_TIMEZONE = "Europe/Moscow";

/**
 * Формат даты/времени дедлайна для CRM (dd.MM.yyyy HH:mm)
 * @type {string}
 */
const DEADLINE_DATETIME_FORMAT = "DD.MM.YYYY HH:mm";

/**
 * Доступные для заказа диапазоны времени
 * @type Array
 */
const TIME_DIAPASONS = [
  {
    name: "08:00 - 11:00",
    to: 8,
  },
  {
    name: "11:00 - 14:00",
    to: 11,
  },
  {
    name: "14:00 - 17:00",
    to: 14,
  },
  {
    name: "17:00 - 20:00",
    to: 17,
  },
  {
    name: "20:00 - 23:00",
    to: 20,
  },
];

const CITIES = [
  {
    id: 76,
    label: "Москва",
  },
  {
    id: 90,
    label: "Лондон",
  },
  {
    id: 1858,
    label: "Санкт-Петербург",
  },
  {
    id: 1859,
    label: "Сочи",
  },
];

export {
  API_URL,
  DAYS_IN_LIST,
  X_APP_TOKEN,
  TIME_DIAPASONS,
  GRAPHQL_API_URL,
  DEADLINE_ADD_MINUTES,
  DEADLINE_ADD_MINUTES_DELIVERY,
  MOSCOW_TIMEZONE,
  DEADLINE_DATETIME_FORMAT,
  CITIES,
};
